import { createContext, useContext } from 'react';
import type { M3Cull } from '../api';

const ApiContext = createContext<M3Cull | null>(null);

export const ApiProvider = ApiContext.Provider;

/** The one way UI code reaches anything below it (rule R1). */
export function useApi(): M3Cull {
  const api = useContext(ApiContext);
  if (!api) throw new Error('useApi was called outside the provider.');
  return api;
}
